/* global appData */
const coolBigIcon = document.querySelector('#coolBigIcon');
export function changeColor(color, ...icons) {
	coolBigIcon.classList.add('changeColor');
	icons.forEach(item => {
		coolBigIcon.classList.add(item);
	});
	if (document.querySelector('#iconBackgroundTransition').classList) {
		document.querySelector('#iconBackgroundTransition').classList.add(color);
	}

	setTimeout(() => {
		removeAll();
		coolBigIcon.classList.add(color);
		icons.forEach(item => {
			coolBigIcon.classList.add(item);
		});
		coolBigIcon.classList.remove('changeColor');
		if (document.querySelector('#iconBackgroundTransition').classList) {
			document.querySelector('#iconBackgroundTransition').classList.remove(color);
		}
	}, 200);
}
export function hasClass(className) {
	return coolBigIcon.classList.contains(className);
}
export function nodIcon() {
	coolBigIcon.classList.add('nod');
	setTimeout(() => {
		coolBigIcon.classList.remove('nod');
	}, 1000);
}
export function removeAll() {
	coolBigIcon.classList.remove('lock');
	coolBigIcon.classList.remove('key');
	coolBigIcon.classList.remove('multiUser');
	coolBigIcon.classList.remove('clock');
	coolBigIcon.classList.remove('shield');
	coolBigIcon.classList.remove('red');
	coolBigIcon.classList.remove('orange');
	coolBigIcon.classList.remove('green');
	coolBigIcon.classList.remove('blue');
}
export function setClockTime() {
	const currentTime = new Date();
	const minutes = currentTime.getMinutes();
	const minuteAngle = (minutes / 60) * 360 - 45;
	const hours = currentTime.getHours();
	const hourAngle = ((hours * 60 + minutes) / 720) * 360 + 60;
	document.querySelector('#minuteHand').style.transform = `rotate(${minuteAngle + 180}deg)`;
	document.querySelector('#hourHand').style.transform = `rotate(${hourAngle}deg)`;
	coolBigIcon.classList.add('animateTime');
	setTimeout(() => {
		coolBigIcon.classList.remove('animateTime');
	}, 15000);
}
export function setTitle(titleId, postScript = '') {
	document.querySelector('#signInTitle').innerHTML = appData.titleStrings[titleId];
	document.querySelector('#signInSubTitle').innerHTML = `${appData.subTitleStrings[titleId]} ${postScript}`;
}
export function shakeIcon() {
	coolBigIcon.classList.add('shake');
	setTimeout(() => {
		coolBigIcon.classList.remove('shake');
	}, 1000);
}
export function swapIcon(title, ...args) {
	if (coolBigIcon.classList.contains('zoomedOut')) {
		removeAll();
		args.forEach(item => {
			coolBigIcon.classList.add(item);
		});
		zoomIn();
		setTitle(title);
	} else {
		zoomOut();
		setTimeout(() => {
			setTitle(title);
			removeAll();
			args.forEach(item => {
				coolBigIcon.classList.add(item);
			});
			zoomIn();
		}, 200);
	}
}
export function zoomIn() {
	coolBigIcon.classList.add('zoomIn');
	setTimeout(() => {
		coolBigIcon.classList.remove('zoomIn');
		coolBigIcon.classList.remove('zoomedOut');
	}, 500);
}
export function zoomOut() {
	coolBigIcon.classList.add('zoomOut');
	setTimeout(() => {
		coolBigIcon.classList.add('zoomedOut');
		coolBigIcon.classList.remove('zoomOut');
	}, 200);
}

// Not ideal to put this on the window, but we want to prevent the possibility of this being called twice.
if (!window.coolBigIconTapIntervalStarted) {
	window.coolBigIconTapIntervalStarted = true;
	setInterval(() => {
		if (
			coolBigIcon.classList.contains('lock') &&
			!coolBigIcon.classList.contains('red') &&
			!coolBigIcon.classList.contains('green')
		) {
			coolBigIcon.classList.add('tap');
			setTimeout(() => {
				coolBigIcon.classList.remove('tap');
			}, 1000);
		}
	}, 45000);
}
